import React from 'react'
import { XIcon } from './Icons'
import '../styles/ShortcutsHelp.css'

const ShortcutsHelp = ({ isOpen, onClose, shortcuts }) => {
  if (!isOpen) return null

  return (
    <div className="shortcuts-overlay" onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="shortcuts-title">
      <div className="shortcuts-modal" onClick={(e) => e.stopPropagation()}>
        <div className="shortcuts-header">
          <h2 id="shortcuts-title">Keyboard Shortcuts</h2>
          <button
            className="shortcuts-close"
            onClick={onClose}
            aria-label="Close shortcuts help"
          >
            <XIcon size={20} />
          </button>
        </div>

        <div className="shortcuts-content">
          {Object.entries(shortcuts).map(([category, items]) => (
            <div key={category} className="shortcuts-category">
              <h3>{category}</h3>
              <div className="shortcuts-list">
                {items.map(({ keys, description }, index) => (
                  <div key={index} className="shortcut-item">
                    <div className="shortcut-keys">
                      {keys.split('+').map((key, i) => (
                        <React.Fragment key={i}>
                          {i > 0 && <span className="shortcut-plus">+</span>}
                          <kbd className="shortcut-key">{key}</kbd>
                        </React.Fragment>
                      ))}
                    </div>
                    <div className="shortcut-description">{description}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="shortcuts-footer">
          <p>Press <kbd>?</kbd> to toggle this help, <kbd>Esc</kbd> to close</p>
        </div>
      </div>
    </div>
  )
}

export default ShortcutsHelp
